import { useScopes } from 'hooks/useScopes';
import { getConnectedPos, getCubohPos } from 'scopes/posHelpers';
import type { PosScopeDetails } from 'scopes/posHelpers';
import type { ConnectedPos } from 'types/pos';

/** The connected POS for the current location, or null when none is connected. */
export const useConnectedPos = (): ConnectedPos | null => {
  // TODO: drop the assertion once useScopes is converted to TypeScript
  const { scopeDetails } = useScopes() as { scopeDetails?: PosScopeDetails };

  return getConnectedPos(scopeDetails ?? {});
};

/** The POS on the Cuboh company whatever its type, unsupported ones included. */
export const useCubohPos = (): ConnectedPos | null => {
  // TODO: drop the assertion once useScopes is converted to TypeScript
  const { scopeDetails } = useScopes() as { scopeDetails?: PosScopeDetails };

  return getCubohPos(scopeDetails ?? {});
};
